import { render, staticRenderFns } from "./UIDropdown.vue?vue&type=template&id=d736c4ec&"
import script from "./UIDropdown.vue?vue&type=script&lang=js&"
export * from "./UIDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UIDropdown.vue?vue&type=style&index=0&id=d736c4ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports